(function () {
  'use strict';
  if (window.SkVisitorContext && window.SkVisitorContext.ready && typeof window.SkVisitorContext.get === 'function') return;

  var configNode = document.getElementById('sk-visitor-context-config');
  var config = {};
  try { config = JSON.parse(configNode ? configNode.textContent : '{}'); } catch (e) {}
  var MANUAL_KEY = 'skVisitorLanguagePreferenceV1';
  var AUTO_KEY = 'skVisitorAutoLanguageV1';
  var AUTO_MAX_AGE = 8 * 60 * 60 * 1000;
  var allowed = Array.isArray(config.availableLanguages) ? config.availableLanguages.map(languageCode).filter(Boolean) : [];
  var pageLanguage = languageCode(config.pageLanguage || document.documentElement.lang) || 'en';
  var explicitLocale = /^\/(fr|de|es|ar|zh(?:-cn)?)(?:\/|$)/i.test(window.location.pathname);
  var formActivity = false;
  var manualAction = false;

  function languageCode(value) {
    var result = String(value || '').toLowerCase().split('-')[0];
    return /^[a-z]{2}$/.test(result) ? result : null;
  }
  function countryCode(value) {
    var result = String(value || '').toUpperCase();
    return /^[A-Z]{2}$/.test(result) ? result : null;
  }
  function readStorage(name, key) {
    try { return window[name].getItem(key); } catch (e) { return null; }
  }
  function writeStorage(name, key, value) {
    try {
      window[name].setItem(key, value);
      return window[name].getItem(key) === value;
    } catch (e) { return false; }
  }
  function readJson(name, key) {
    try { return JSON.parse(readStorage(name, key) || 'null'); } catch (e) { return null; }
  }
  function readManualPreference() {
    var stored = readJson('localStorage', MANUAL_KEY) || readJson('sessionStorage', MANUAL_KEY);
    var code = stored && languageCode(stored.language);
    return code && allowed.indexOf(code) !== -1 ? code : null;
  }
  function readAutoAttempt() {
    var stored = readJson('sessionStorage', AUTO_KEY);
    if (!stored || ['manual', 'geoip_default'].indexOf(stored.source) === -1 || typeof stored.at !== 'number') return null;
    if (Date.now() - stored.at < 0 || Date.now() - stored.at > AUTO_MAX_AGE) return null;
    return allowed.indexOf(languageCode(stored.language)) !== -1 ? stored : null;
  }
  var manualLanguage = readManualPreference();
  var previousAttempt = readAutoAttempt();
  var selectionSource = manualLanguage === pageLanguage ? 'manual' : explicitLocale ? 'explicit_locale_url' : 'default';
  if (config.autoLanguageEnabled === true && previousAttempt && languageCode(previousAttempt.language) === pageLanguage) {
    if (previousAttempt.source === 'manual') selectionSource = 'manual';
    else if (!manualLanguage) selectionSource = 'geoip_default';
  }
  if (!explicitLocale && manualLanguage !== pageLanguage && previousAttempt && languageCode(previousAttempt.language) !== pageLanguage && config.autoLanguageEnabled === true) selectionSource = 'unconfirmed';
  var snapshot = {
    ipCountry: null,
    ipCountryName: null,
    ipCountrySource: 'Not detected',
    detectedAt: null,
    storefrontCountry: countryCode(config.storefrontCountry || (window.Shopify && window.Shopify.country)),
    pageLanguage: pageLanguage,
    browserLanguage: String(navigator.language || '').slice(0, 100),
    languageSelectionSource: selectionSource
  };
  function getSnapshot() {
    return Object.assign({}, snapshot);
  }
  function isLocalizationForm(form) {
    if (!form || String(form.tagName).toLowerCase() !== 'form') return false;
    var type = form.querySelector('input[name="form_type"]');
    if (type && type.value === 'localization') return true;
    try { return /\/localization\/?$/.test(new URL(form.action, window.location.href).pathname); } catch (e) { return false; }
  }
  function rememberManual(code) {
    code = languageCode(code);
    if (!code || allowed.indexOf(code) === -1) return;
    manualLanguage = code;
    manualAction = true;
    snapshot.languageSelectionSource = 'manual';
    var value = JSON.stringify({ language: code, at: Date.now(), source: 'manual' });
    writeStorage('localStorage', MANUAL_KEY, value);
    writeStorage('sessionStorage', MANUAL_KEY, value);
    try { window.sessionStorage.removeItem(AUTO_KEY); } catch (e) {}
  }
  function formLanguage(form, submitter) {
    if (submitter && /^(?:language_code|locale_code)$/.test(submitter.name || '')) return submitter.value;
    var input = form.querySelector('input[name="language_code"], input[name="locale_code"], select[name="language_code"], select[name="locale_code"]');
    return input ? input.value : null;
  }
  // Dawn's footer submits directly with form.submit(), so its data-value click
  // must be captured before the component changes the hidden locale field.
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('button, input, a[data-value]') : null;
    var form = target && target.closest('form');
    if (!isLocalizationForm(form) || form.hasAttribute('data-sk-visitor-auto')) return;
    if (/^(?:language_code|locale_code)$/.test(target.name || '')) rememberManual(target.value);
    else if (target.matches('a[data-value]') && form.querySelector('input[name="locale_code"], input[name="language_code"]')) rememberManual(target.getAttribute('data-value'));
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (isLocalizationForm(form) && !form.hasAttribute('data-sk-visitor-auto')) rememberManual(formLanguage(form, event.submitter));
  }, true);
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input && isLocalizationForm(input.form) && /^(?:language_code|locale_code)$/.test(input.name || '')) rememberManual(input.value);
  }, true);
  ['input', 'change'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var control = event.target;
      if (control && control.form && !isLocalizationForm(control.form) && control.type !== 'hidden') formActivity = true;
    }, true);
  });

  function hasFormProgress() {
    if (formActivity) return true;
    return Array.prototype.some.call(document.forms, function (form) {
      if (isLocalizationForm(form)) return false;
      var formType = form.querySelector('input[name="form_type"]');
      var isLeadForm = formType && /^(contact|customer)$/.test(formType.value);
      return Array.prototype.some.call(form.querySelectorAll('input, textarea, select'), function (input) {
        var type = String(input.type || '').toLowerCase();
        if (input.disabled || /^(hidden|submit|button|reset)$/.test(type)) return false;
        if (type === 'file') return !!(input.files && input.files.length);
        if (type === 'checkbox' || type === 'radio') return input.checked !== input.defaultChecked;
        if (input.tagName === 'SELECT') {
          var hasDefault = Array.prototype.some.call(input.options, function (option) { return option.defaultSelected; });
          return Array.prototype.some.call(input.options, function (option, index) {
            var defaultSelected = hasDefault ? option.defaultSelected : !input.multiple && index === 0;
            return option.selected !== defaultSelected;
          });
        }
        var value = String(input.value || '').trim();
        if (!value) return false;
        return !!isLeadForm || type === 'email' || type === 'tel' || String(input.value) !== String(input.defaultValue);
      });
    });
  }
  function countryLanguage(code) {
    if (/^(US|CA|AU|GB|NZ|IE)$/.test(code)) return 'en';
    if (code === 'FR') return 'fr';
    if (code === 'DE') return 'de';
    if (/^(ES|MX|AR|BO|CL|CO|CR|CU|DO|EC|SV|GT|HN|NI|PA|PY|PE|PR|UY|VE)$/.test(code)) return 'es';
    if (/^(DZ|BH|KM|DJ|EG|IQ|JO|KW|LB|LY|MR|MA|OM|PS|QA|SA|SO|SD|SY|TN|AE|YE)$/.test(code)) return 'ar';
    // [Claude 2026-11-04] 简体中文上线：中国大陆/台湾/香港/澳门 → zh-CN（老板令：按 IP 自动切换当地语言）
    if (/^(CN|TW|HK|MO)$/.test(code)) return 'zh';
    return 'en';
  }
  function shouldSkipAutomatic() {
    if (config.autoLanguageEnabled !== true) return true;
    if (manualAction || explicitLocale || previousAttempt) return true;
    if (config.designMode || (window.Shopify && (window.Shopify.designMode || window.Shopify.inspectMode))) return true;
    if (/(bot|crawl|spider|slurp|bingpreview|facebookexternalhit|googleother|lighthouse)/i.test(navigator.userAgent || '')) return true;
    var url = new URL(window.location.href);
    if (/^\/(?:[^/]{2}\/)?(?:cart|checkout|checkouts|account|accounts|challenge|checkpoint|password|localization)(?:\/|$)/i.test(url.pathname)) return true;
    if (/\/(?:robots\.txt|sitemap[^/]*\.xml)$/i.test(url.pathname)) return true;
    var skipParams = ['preview_theme_id', 'preview_token', 'contact_posted', 'customer_posted', 'form_type', 'challenge', 'locale', 'language', 'language_code'];
    if (skipParams.some(function (key) { return url.searchParams.has(key); })) return true;
    try { if (document.referrer && new URL(document.referrer).origin === window.location.origin) return true; } catch (e) {}
    return hasFormProgress();
  }
  function maybeApplyIpLanguage() {
    if (shouldSkipAutomatic()) return;
    var target = manualLanguage || (snapshot.ipCountry && countryLanguage(snapshot.ipCountry));
    var source = manualLanguage ? 'manual' : 'geoip_default';
    if (!target || allowed.indexOf(target) === -1) return;
    if (target === pageLanguage) {
      snapshot.languageSelectionSource = source;
      return;
    }
    // A durable session marker is required before changing the page. If browser
    // storage is unavailable, keep the current page and avoid a redirect loop.
    var attempt = { language: target, country: snapshot.ipCountry, source: source, at: Date.now() };
    if (!writeStorage('sessionStorage', AUTO_KEY, JSON.stringify(attempt))) return;
    previousAttempt = attempt;
    snapshot.languageSelectionSource = 'unconfirmed';
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;
    form.setAttribute('data-sk-visitor-auto', 'true');
    var fields = {
      form_type: 'localization',
      _method: 'put',
      utf8: '\u2713',
      // [Claude 2026-11-04] Shopify 需要完整语言码（zh-CN）；内部比较用两位码
      language_code: (Array.isArray(config.availableLanguages) ? config.availableLanguages : []).filter(function (l) { return languageCode(l) === target; })[0] || target,
      return_to: window.location.pathname + window.location.search + window.location.hash
    };
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = fields[name]; form.appendChild(input);
    });
    document.body.appendChild(form);
    try { HTMLFormElement.prototype.submit.call(form); } catch (e) { form.remove(); }
  }

  var detection = new Promise(function (resolve) {
    var settled = false;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    function finish(data) {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      var country = data && data.detected_values && data.detected_values.country;
      var code = country && countryCode(country.handle);
      if (code) {
        snapshot.ipCountry = code;
        snapshot.ipCountryName = String(country.name || code).trim().slice(0, 100);
        snapshot.ipCountrySource = 'Shopify GeoIP';
        snapshot.detectedAt = new Date().toISOString();
      }
      resolve(getSnapshot());
    }
    var timer = window.setTimeout(function () {
      finish(null);
      if (controller) controller.abort();
    }, 3000);
    if (typeof window.fetch !== 'function') { finish(null); return; }
    var root = config.localeRoot || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var endpoint = new URL(String(root).replace(/\/?$/, '/') + 'browsing_context_suggestions.json', window.location.origin);
    endpoint.searchParams.set('country[enabled]', 'true');
    endpoint.searchParams.set('language[enabled]', 'true');
    var options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (controller) options.signal = controller.signal;
    Promise.resolve().then(function () { return window.fetch(endpoint.href, options); }).then(function (response) {
      if (!response.ok) throw new Error('Geo detection unavailable');
      return response.json();
    }).then(finish, function () { finish(null); });
  });
  var ready = detection.then(function () {
    try { maybeApplyIpLanguage(); } catch (e) {}
    return getSnapshot();
  }, function () { return getSnapshot(); });
  window.SkVisitorContext = { ready: ready, get: getSnapshot };
})();
